import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import logo from '../../assets/images/newlogo2.png';
import editicon from '../../assets/images/editicon.svg';
import defaultFoto from '../../assets/images/foto.jpeg';
// import stravaLogo from '../../assets/images/strava.svg';
import './header.scss';

const Header = ({ resetFilters, showReset, signUp, history }) => {
  const [currentAthlete, setCurrentAthlete] = useState({});
  const [currentName, setCurrentName] = useState();

  useEffect(() => {
    const athlete = JSON.parse(localStorage.getItem('userData'));
    console.log('athlete', athlete);
    if (athlete && athlete.user) {
      setCurrentAthlete(athlete.user);
      const newCurrentName = athlete.user.name.split(' ')[0];
      setCurrentName(newCurrentName);
    }
  }, []);

  const goEdit = () => {
    history.push(`/edit`);
  };

  const goHome = () => {
    history.push(`/`);
  };

  const openIG = () => {
    window.open('https://www.instagram.com/12h.run/', '_blank');
  };

  return (
    <header className='header'>
      {!signUp && (
        <div className='edit-info-container'>
          {currentAthlete && currentAthlete.photoUrl && (
            <div
              className={`header_profile-photo-container hover`}
              onClick={() => {
                goEdit();
              }}
            >
              <img
                src={currentAthlete.photoUrl || defaultFoto}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = defaultFoto;
                }}
                alt='profile'
                className='header_profile-photo'
              />
              <img src={editicon} alt='edit icon' className='edit_icon' />
            </div>
          )}
          {currentName && (
            <div className='name-container hide-mobile'>
              Hola,
              <br /> {currentName}
            </div>
          )}
        </div>
      )}

      <div className='header_container_logo'>
        <img src={logo} alt='logo' className='header_logo' onClick={goHome} />
      </div>
      {showReset && !signUp && (
        <div className='reset-filters' onClick={resetFilters}>
          Limpiar Filtros
        </div>
      )}
      {/* <div className='add-button-container'>
        <img
          src={stravaLogo}
          alt='strava logo'
          className='header_strava_logo'
        />
        <div className='add-button'>+</div>
      </div> */}
    </header>
  );
};

Header.propTypes = {
  resetFilters: PropTypes.func,
  showReset: PropTypes.bool,
  signUp: PropTypes.bool,
};

Header.defaultProps = {
  signUp: false,
  resetFilters: null,
  showReset: null,
};

export default withRouter(Header);
